import path from 'node:path'
import fs from 'node:fs'

export const CONFIG_FILE_NAME = 'scalar.config'
export const DEFAULT_CONFIG_EXTENSION = '.json5'
export const CONFIG_FILE_DEFAULT = CONFIG_FILE_NAME + DEFAULT_CONFIG_EXTENSION // Default to .json5
type ConfigFilePath = string | null

/**
 * Finds Scalar configuration file in the specified directory
 * Searches for files named 'scalar.config' with any extension, or without extension
 *
 * @param searchPath - Path to search in, can be directory or file path, defaults to current working directory if null
 * @returns Path to the found configuration file, or null if not found
 */
export function findConfig(searchPath?: string): ConfigFilePath {
  // If no path provided, use current working directory
  if (!searchPath) {
    return searchInDirectory(process.cwd())
  }

  const searchPathResolved = path.resolve(searchPath)
  const stat = fs.statSync(searchPathResolved, { throwIfNoEntry: false })
  if (!stat) {
    return null
  }
  if (stat.isDirectory()) {
    return searchInDirectory(searchPathResolved)
  }
  if (stat.isFile()) {
    return searchPathResolved
  }
  return null
}

/**
 * Helper function to search for config files in a specific directory
 */
function searchInDirectory(directory: string): ConfigFilePath {
  try {
    // Read the directory entries
    const entries = fs.readdirSync(directory)

    // Look for any file starting with CONFIG_FILE_NAME
    for (const entry of entries) {
      if (
        entry === CONFIG_FILE_NAME ||
        entry.startsWith(`${CONFIG_FILE_NAME}.`)
      ) {
        return path.join(directory, entry)
      }
    }

    return null
  } catch (_) {
    return null
  }
}
